// import jsxc from 'jsxc'
export function Keys (pup, pleft, pright, pdown) {
  var up = pup || false
  var left = pleft || false
  var right = pright || false
  var down = pdown || false

  var onKeyDown = function (e) {
    var that = this
    var c = e.keyCode
    // console.log(c)
    switch (c) {
      // Controls
      case 37: // Left
        that.left = true
        break
      case 38: // Up
        that.up = true
        // jsxc.muc.joinChat('pooh', 'pepito')
        break
      case 39: // Right
        that.right = true // Will take priority over the left key
        break
      case 40: // Down
        that.down = true
        break
    }
  }

  var onKeyUp = function (e) {
    var that = this
    var c = e.keyCode
    switch (c) {
      // Controls
      case 37: // Left
        that.left = false
        break
      case 38: // Up
        that.up = false
        break
      case 39: // Right
        that.right = false // Will take priority over the left key
        break
      case 40: // Down
        that.down = false
        break
    }
  }

  return {
    up: up,
    left: left,
    right: right,
    down: down,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  }
}



// WEBPACK FOOTER //
// ./src/core/Keys.js